import WhatsApp from '../../assets/social/whatsapp.svg';
import Youtube from '../../assets/social/youtube.svg';
import Tiktok from '../../assets/social/tiktok.svg';
import Facebook from '../../assets/social/facebook.svg';
import Instagram from '../../assets/social/instagram.svg';

const ContactUsAddress = () => {
    const socialLinks = [
        {
            id: 1,
            link: "https://wa.me/+447712279245",
            imgSrc: WhatsApp,
            alt: "whatsapp",
            label: "WhatsApp"
          },
          {
            id: 2,
            link: "https://www.youtube.com/@haloholidays",
            imgSrc: Youtube,
            alt: "youtube",
            label: "YouTube"
          },
          {
            id: 3,
            link: "https://www.tiktok.com/@haloholidays.uk",
            imgSrc: Tiktok,
            alt: "tiktok",
            label: "Tiktok"
          },
          {
            id: 4,
            link: "https://www.facebook.com/haloholidays.co.uk",
            imgSrc: Facebook,
            alt: "facebook",
            label: "Facebook"
          },
          {
            id: 5,
            link: "https://www.instagram.com/haloholidays.uk/",
            imgSrc: Instagram,
            alt: "instagram",
            label: "Instagram"
          }
    ];

    return (
        <div>
            <div className="w-full">
                <div className="text-2xl md:text-3xl sm:text-2xl font-semibold pb-6">Contact Us</div>
            </div>
            <div className="flex flex-col md:flex-row gap-8 justify-between">
                {/* Contact Details */}
                <div className="flex-shrink space-y-4">
                    <div>
                        <div className="text-sm text-gray-500">General Line</div>
                        <a href="tel:020 7290 5570" className="text-base md:text-lg font-medium hover:underline">
                            020 7290 5570
                        </a>
                    </div>
                    <div>
                        <div className="text-sm text-gray-500">Customer Care</div>
                        <a href="tel:020 7290 5571" className="text-base md:text-lg font-medium hover:underline">
                            020 7290 5571
                        </a>
                    </div>
                    <div>
                        <div className="text-sm text-gray-500">Complaints</div>
                        <a href="tel:020 7290 5572" className="text-base md:text-lg font-medium hover:underline">
                            020 7290 5572
                        </a>
                    </div>
                </div>

                {/* Address */}
                <div className="lg:w-1/4">
                    <div className="text-sm text-gray-500">Address</div>
                    <div className="text-base md:text-lg font-medium text-black">
                        15A Cobalt Business Park, 1 Quick Silver Way, Newcastle upon Tyne, London NE27 0QQ
                    </div>
                </div>

                {/* Support */}
                <div className="flex-shrink space-y-2">
                    <div className="text-sm text-gray-500">Need live support?</div>
                    <a href="mailto:contact@haloholidays.co.uk" className="text-base md:text-lg font-medium hover:underline">
                        contact@haloholidays.co.uk
                    </a>
                </div>

                {/* Social Links */}
                <div className="flex-shrink space-y-2">
                    <div className="text-sm text-gray-500">Follow us on social media</div>
                    <div className="flex gap-x-4 items-center">
                        {socialLinks.map((link) => (
                            <a
                                key={link.id}
                                href={link.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={link.label}
                                className="hover:opacity-60 transition-opacity"
                            >
                                <img src={link.imgSrc} alt={link.alt} className="w-5 h-5" />
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUsAddress;